import { Injectable, signal } from '@angular/core';

export interface DemoField { name: string; label: string; type?: string; }
export interface DemoDialog { title: string; description: string; fields?: readonly DemoField[]; submit?: (values: Record<string, string>) => void; }
@Injectable({ providedIn: 'root' })
export class DemoUiService {
  readonly dialog = signal<DemoDialog | null>(null);
  readonly message = signal('');
  private timeout?: ReturnType<typeof setTimeout>;
  open(dialog: DemoDialog): void { this.dialog.set(dialog); }
  close(): void { this.dialog.set(null); }
  notify(message: string): void {
    this.message.set(message); clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.message.set(''), 5500);
  }
  access(role: string): void {
    this.open({ title: role === 'policía' ? 'Acceso policial' : 'Acceso de residente', description: 'Explora el acceso de demostración. No uses credenciales reales.', fields: [
      { name: 'email', label: 'Correo electrónico', type: 'email' }, { name: 'password', label: 'Contraseña de ejemplo', type: 'password' }
    ], submit: () => { this.notify('Acceso simulado. No se verificaron credenciales.'); document.getElementById('operacion')?.scrollIntoView(); } });
  }
}
